// Ported ~verbatim from nenda-autoplayer's src/lib/state/events.ts. One
// delta: `FetchAdsDone.output` is `never`, not the upstream `AdSlot` - since
// `ScheduleClient.getAdSlot()` (src/tv/signage/foyerScheduleClient.ts) always
// rejects (confirmed unreachable given Foyer's adapter output, see that
// file's own doc comment), this event can never actually fire. Typing it
// `never` says so honestly, and avoids porting the AdSlot type for a shape
// nothing will ever construct.
import { MediaAsset, Schedule } from "../types/Schedule";
import { LogLevel } from "../types/LogEntry";

export enum AssetCompleteStatus {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

export interface AssetCompleteSuccessEvent {
  type: "ASSET_COMPLETE";
  status: AssetCompleteStatus.SUCCESS;
  asset?: MediaAsset;
}

export interface AssetCompleteErrorEvent {
  type: "ASSET_COMPLETE";
  asset?: MediaAsset;
  status: AssetCompleteStatus.ERROR;
  error: Error;
}

export type AssetCompleteEvent =
  | AssetCompleteSuccessEvent
  | AssetCompleteErrorEvent;

export interface RestartPlaylistEvent {
  type: "RESTART_PLAYLIST";
}

export interface PlayContentEvent {
  type: "PLAY_CONTENT";
}

export interface PlayAdEvent {
  type: "PLAY_AD";
}

export interface PlaySignageEvent {
  type: "PLAY_SIGNAGE";
}

export interface ToggleDebugEvent {
  type: "TOGGLE_DEBUG";
}

export interface FetchScheduleDone {
  type: "xstate.done.actor.fetchSchedule";
  output: Schedule;
}

/** See this file's own header comment: unreachable given Foyer's scope. */
export interface FetchAdsDone {
  type: "xstate.done.actor.fetchAds";
  output: never;
}

export interface RedBeeAuthDone {
  type: "xstate.done.actor.authenticateRedBeeUser";
  output: {
    sessionToken: string;
  };
}

export interface ContentChanged {
  type: "CONTENT_CHANGED";
}

export interface LogEvent {
  type: "LOG";
  payload: {
    component: string;
    message?: string;
    level?: LogLevel;
    asset?: MediaAsset;
  };
}

export interface NoNetworkEvent {
  type: "NO_NETWORK";
}

export interface NetworkRestoredEvent {
  type: "NETWORK_RESTORED";
}
export interface PlaybackCircuitBreakerHalfOpenedEvent {
  type: "PLAYBACK_CIRCUITBREAKER_HALF_OPENED";
}

export interface AdvanceContentEvent {
  type: "ADVANCE_CONTENT";
}

export type AutoplayerMachineEvent =
  | AssetCompleteSuccessEvent
  | AssetCompleteErrorEvent
  | AssetCompleteEvent
  | RestartPlaylistEvent
  | ToggleDebugEvent
  | PlayContentEvent
  | PlayAdEvent
  | PlaySignageEvent
  | FetchScheduleDone
  | FetchAdsDone
  | ContentChanged
  | LogEvent
  | RedBeeAuthDone
  | NoNetworkEvent
  | NetworkRestoredEvent
  | PlaybackCircuitBreakerHalfOpenedEvent
  | AdvanceContentEvent;
